import { ShadowMaterial, ShadowMaterialParameters } from '../../thirdparty/three/imports';
import { Material3D } from './Material3D';

export interface ShadowMaterial3D
{
    get _material(): ShadowMaterial;
    set _material(v: ShadowMaterial);
}

export class ShadowMaterial3D extends Material3D
{
    get color()
    {
        return this._material.color;
    }
    set color(v)
    {
        this._material.color = v;
    }

    constructor(parameters?: ShadowMaterialParameters)
    {
        super();
        this._material = new ShadowMaterial(parameters);
    }
}
